import { createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48a73e71"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["value"]
const _hoisted_2 = ["label"]
const _hoisted_3 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Fieldset = _resolveComponent("Fieldset")!
  const _component_Space = _resolveComponent("Space")!

  return (_openBlock(), _createBlock(_component_Space, {
    key: _ctx.rerenderKey,
    vertical: "",
    xlarge: "",
    full: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Fieldset, { label: "フォント選択" }, {
        default: _withCtx(() => [
          _createElementVNode("select", {
            value: _ctx.modelValue,
            onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
            class: "font-select"
          }, [
            _createCommentVNode(" <option\n          v-for=\"category in fonts\"\n          :key=\"category.label\"\n          disabled\n        >{{ category.label }}</option> "),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fonts, (category) => {
              return (_openBlock(), _createElementBlock("optgroup", {
                key: category.label + '-group',
                label: category.label
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.fonts, (font) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: font.label,
                    value: font.value,
                    style: _normalizeStyle({ font: font.value, lineHeight: 1 })
                  }, _toDisplayString(font.loaded ? font.label : 'loading ...'), 13 /* TEXT, STYLE, PROPS */, _hoisted_3))
                }), 128 /* KEYED_FRAGMENT */))
              ], 8 /* PROPS */, _hoisted_2))
            }), 128 /* KEYED_FRAGMENT */))
          ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_1)
        ]),
        _: 1 /* STABLE */
      }),
      _createCommentVNode(" <Fieldset label=\"その他のフォント\">\n      <Space vertical>\n        <FileSelect type=\"font\" name=\"ファイルを選ぶ\" @load=\"onLoadFont\">\n          <Text /> ファイルを選ぶ\n        </FileSelect>\n        <Input\n            v-if=\"showDetails\"\n            v-model=\"stringValue\"\n            name=\"font-spec\"\n            block :error=\"!stringIsValid\" />\n      </Space>\n    </Fieldset> ")
    ]),
    _: 1 /* STABLE */
  }))
}